var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 134,
    viewBox: "0 0 157 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.138 44.4456C97.138 54.863 88.693 63.308 78.2745 63.308C67.8571 63.308 59.4121 54.863 59.4121 44.4456C59.4121 34.0282 67.8571 25.5833 78.2745 25.5833C88.693 25.5833 97.138 34.0282 97.138 44.4456Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.605 13.3102L143.293 0V11.3139L76.001 9.03158C44.2357 9.03158 18.389 34.8768 18.389 66.6435C18.389 86.9797 28.9878 104.873 44.9436 115.127L13.5981 117.409V106.544L0.289062 119.854L13.5981 133.166V121.972L79.4087 124.254C111.177 124.254 137.021 98.4095 137.021 66.6416C137.021 46.3077 126.42 28.4124 110.464 18.1554L143.293 15.8753V26.6198L156.605 13.3102ZM127.893 66.6421C127.893 84.8348 117.816 100.708 102.958 109.003C102.952 98.5806 102.938 89.7108 102.917 89.5149C102.109 76.8003 91.2359 66.7552 78.2808 66.7721C65.4408 66.7983 54.9059 76.7306 53.9686 89.2883C53.9458 89.4819 53.9344 98.9098 53.931 109.79C38.2644 101.744 27.5143 85.4296 27.5143 66.6418C27.5143 39.9074 49.2661 18.1556 75.9976 18.1556H79.4062C106.142 18.1556 127.892 39.9065 127.892 66.6418L127.893 66.6421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVisitors);
export default __webpack_public_path__ + "static/media/totalVisitors.88138e7b6fa1da7000cc90e251491449.svg";
export { ForwardRef as ReactComponent };